import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Flex, Img, useStyleConfig} from '@chakra-ui/react'
import {EditorialVideo} from '../../video'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {remCalc} from '../../../../theme/_utils'

export const ThreeMedia = ({media1, media2, media3}) => {
    const styles = useStyleConfig('Gallery')

    const damImage1 = useDamImage(media1?.image)
    const damImage2 = useDamImage(media2?.image)
    const damImage3 = useDamImage(media3?.image)

    return (
        <Flex
            flexDirection={{base: 'column', md: 'row'}}
            justifyContent={{base: 'flex-start', md: 'center'}}
            gap={{base: remCalc(16), lg: remCalc(24)}}
            className={'threeMediaLayout'}
        >
            <Flex
                flexDirection={'column'}
                gap={remCalc(16)}
                w={{base: '100%', md: '50%'}}
                justifyContent={'space-between'}
                alignItems={{base: 'center', md: 'flex-end'}}
            >
                {media1?.is_video ? (
                    <EditorialVideo
                        data={media1?.video && media1?.video?.length ? media1?.video[0] : null}
                        data-testid="gallery-3-media"
                        {...styles.halfMedia}
                    />
                ) : (
                    (damImage1.url || media1?.image?.alt) && (
                        <AspectRatio
                            ratio={damImage1.ratio}
                            {...styles.halfMedia}
                            data-testid="gallery-3-media"
                        >
                            <Img src={damImage1.url} alt={media1?.image?.alt || ''} />
                        </AspectRatio>
                    )
                )}
                {media2?.is_video ? (
                    <EditorialVideo
                        data={media2?.video && media2?.video?.length ? media2?.video[0] : null}
                        data-testid="gallery-3-media"
                        {...styles.halfMedia}
                    />
                ) : (
                    (damImage2.url || media2?.image?.alt) && (
                        <AspectRatio
                            ratio={damImage2.ratio}
                            {...styles.halfMedia}
                            data-testid="gallery-3-media"
                        >
                            <Img src={damImage2.url} alt={media2?.image?.alt || ''} />
                        </AspectRatio>
                    )
                )}
            </Flex>
            <Flex
                flexDirection={'column'}
                w={{base: '100%', md: '50%'}}
                justifyContent={'flex-start'}
                alignItems={{base: 'center', md: 'flex-start'}}
            >
                {media3?.is_video ? (
                    <EditorialVideo
                        data={media3?.video && media3?.video?.length ? media3?.video[0] : null}
                        data-testid="gallery-3-media"
                        {...styles.halfMedia}
                    />
                ) : (
                    (damImage3.url || media3?.image?.alt) && (
                        <AspectRatio
                            ratio={damImage3.ratio}
                            {...styles.halfMedia}
                            data-testid="gallery-3-media"
                        >
                            <Img src={damImage3.url} alt={media3?.image?.alt || ''} />
                        </AspectRatio>
                    )
                )}
            </Flex>
        </Flex>
    )
}

ThreeMedia.propTypes = {
    media1: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
    media2: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
    media3: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
}
